import AlertContainer from "../../components/uiKits/alert";

const Alert = () => {
  return <AlertContainer />;
};

export default Alert;
